import React from "react";
import ResearchLayout, { useReveal } from "../ResearchLayout";

const MISSION = [
  "Partner with national and international research communities and industries, including pharmaceutical companies to improve patient health care.",
  "Enhance collaborative research among clinical and research faculty, Medical Officers, Associate medical officers, residents, and fellows.",
  "Build strong ties with sponsors.",
  "Foster shared responsibility, ethical research conduct, and compliance.",
  "Develop the researcher's capabilities to get and manage research grants.",
  "Organize training workshop series in expert scientific research guidance for capacity building of trainees, medical officers and research officers.",
  "Organize a research seminar series to enable research fellows and clinicians to present and discuss their findings.",
];

export default function VisionMission() {
  useReveal();
  return (
    <ResearchLayout>
      {/* Hero */}
      <section
        style={{
          padding: "100px 0 60px",
          background: "linear-gradient(135deg, #0d3b6e 0%, #076cec 100%)",
          color: "#fff",
          position: "relative",
          overflow: "hidden",
        }}
      >
        <div className="rs-blob" style={{ width: 400, height: 400, background: "#04b3bf", top: "-150px", left: "-100px" }} />
        <div className="rs-container rs-text-center" style={{ position: "relative", zIndex: 2 }}>
          <span
            className="rs-section-eyebrow"
            style={{ background: "rgba(255,255,255,0.15)", color: "#fff", backdropFilter: "blur(10px)" }}
          >
            Purpose & Direction
          </span>
          <h1 style={{ fontSize: "clamp(2rem, 5vw, 3.4rem)", fontWeight: 800, margin: "12px 0 0" }}>
            Vision &amp; Mission
          </h1>
        </div>
      </section>

      {/* Vision */}
      <section className="rs-section" style={{ paddingTop: 60, paddingBottom: 40 }}>
        <div className="rs-container">
          <div
            className="rs-reveal"
            style={{
              background: "#fff",
              borderRadius: 24,
              padding: 48,
              border: "1px solid rgba(7, 108, 236,0.08)",
              position: "relative",
              overflow: "hidden",
              boxShadow: "0 20px 50px rgba(7, 108, 236,0.08)",
            }}
          >
            <div
              style={{
                position: "absolute",
                top: -60,
                right: -60,
                width: 250,
                height: 250,
                borderRadius: "50%",
                background: "linear-gradient(135deg, rgba(7, 108, 236,0.08), rgba(4, 179, 191,0.08))",
              }}
            />

            <div
              style={{
                width: 70,
                height: 70,
                borderRadius: 18,
                background: "var(--rs-grad-1)",
                color: "#fff",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontSize: "1.8rem",
                marginBottom: 20,
                boxShadow: "0 10px 24px rgba(7, 108, 236,0.3)",
              }}
            >
              <i className="fa-regular fa-eye"></i>
            </div>

            <span className="rs-section-eyebrow">Our Vision</span>
            <h2 className="rs-section-title" style={{ fontSize: "clamp(1.5rem, 3vw, 2rem)" }}>
              Empowering Pakistan's Future in <span className="accent">Clinical &amp; Translational Research</span>
            </h2>
            <p style={{ fontSize: "1.1rem", lineHeight: 1.8, color: "#374151", maxWidth: 900, margin: 0 }}>
              To provide high-quality clinical and translational research facilities and promote interactions
              among clinicians, scientists and researchers. We want to train clinicians in the field of medical
              research and conduct clinical trials in a safe environment according to good clinical practices and
              international standards.
            </p>
          </div>
        </div>
      </section>

      {/* Mission */}
      <section className="rs-section" style={{ paddingTop: 0 }}>
        <div className="rs-container">
          <div className="rs-reveal rs-text-center" style={{ marginBottom: 48 }}>
            <span className="rs-section-eyebrow">Our Mission</span>
            <h2 className="rs-section-title">
              How We <span className="accent">Implement Our Vision</span>
            </h2>
            <p className="rs-section-sub">
              To become the clinical trial site of choice, the research department will:
            </p>
          </div>

          <div
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(auto-fit, minmax(320px, 1fr))",
              gap: 20,
            }}
          >
            {MISSION.map((m, i) => (
              <div
                key={i}
                className={`rs-card rs-reveal delay-${(i % 4) + 1}`}
                style={{ display: "flex", gap: 18, alignItems: "flex-start" }}
              >
                <div
                  style={{
                    flexShrink: 0,
                    width: 44,
                    height: 44,
                    borderRadius: 12,
                    background: "linear-gradient(135deg, rgba(7, 108, 236,0.1), rgba(4, 179, 191,0.1))",
                    color: "var(--rs-primary)",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    fontWeight: 800,
                    fontSize: "1.1rem",
                  }}
                >
                  {String(i + 1).padStart(2, "0")}
                </div>
                <p style={{ margin: 0, color: "#374151", lineHeight: 1.6, fontSize: "0.95rem" }}>{m}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
    </ResearchLayout>
  );
}
